module.exports = __webpack_public_path__ + "assets/ivc-activated.e4c6977e.svg";